module.exports = __webpack_public_path__ + "img/mountain-white.15c4ab36.svg";